module.exports = __webpack_public_path__ + "static/media/balmain-2.7253435d.jpg";